var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 279.881 279.881",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M153.905,130.755c2.562-5.39,5.695-12.222,8.169-18.4c2.241-5.57-0.315-13.201-5.314-16.529 C124.589,74.369,15.465,12.559,3.118,151.467c-0.533,5.983-1.594,6.054-2.187,0.076C-1.157,130.63-2.13,84.415,25.457,59.531 c4.46-4.019,12.319-9.801,17.345-13.086c17.884-11.71,62.767-31.857,127.318,2.594c5.303,2.828,10.476,0.598,11.727-5.276 l4.493-21.142c1.246-5.874,4.775-6.467,7.887-1.327l52.917,87.563c3.106,5.14,0.865,10.334-5.009,11.607l-82.375,17.764 C153.878,139.496,151.327,136.178,153.905,130.755z M236.247,239.357c-17.884,11.694-62.761,31.802-127.318-2.622 c-5.303-2.828-11.047-0.756-12.994,4.928l-5.466,15.958c-1.947,5.684-5.793,5.978-8.588,0.658l-42.256-80.444 c-2.796-5.319-0.402-11.052,5.347-12.804l69.832-21.332c5.744-1.751,9.1,1.517,7.5,7.316c-1.795,6.489-4.117,14.947-6.081,22.175 c-1.572,5.798,1.137,13.353,6.206,16.589c32.553,20.766,142.743,80.319,154.741-56.653c0.522-5.983,1.496-6.032,2.007-0.049 c1.806,21.153,2.197,68.157-25.58,93.198C249.133,230.29,241.279,236.072,236.247,239.357z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshButton);
export default __webpack_public_path__ + "static/media/RefreshButton.0bf176b98a27f891cb3d2257065f4df5.svg";
export { ForwardRef as ReactComponent };